import { ReactNode, useEffect, useRef, useState } from 'react';

import { Box, Icon, Link } from '@core/component';
import { EActionAttribute, EColor, EIcon, EPosition } from '@core/type';

import { TableContent } from './interface-table-of-content';

export const TableOfContentItem = ({
  title,
  children,
  onClick,
  isActive,
  isToggleable,
}: Pick<TableContent, 'title' | 'isActive'> & {
  children: ReactNode;
  onClick: (text: string) => void;
  isToggleable: boolean;
}) => {
  const childrenContentRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [height, setHeight] = useState<number>(childrenContentRef?.current?.offsetHeight);

  useEffect(() => {
    setHeight(childrenContentRef?.current?.offsetHeight);
  }, [isOpen, childrenContentRef?.current?.offsetHeight]);

  const handleToggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <Box as={EActionAttribute.LI}>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Box padding={'12px 16px'}>
          <Link color={isActive ? EColor.ACCENT : EColor.SECONDARY} onClick={() => onClick(title)}>
            {title}
          </Link>
        </Box>
        {isToggleable && (
          <Box role={'button'} onClick={handleToggle} padding={'12px 16px'} cursor={'pointer'}>
            <Icon type={EIcon.ANGLE} orientation={isOpen ? EPosition.TOP : EPosition.BOTTOM} />
          </Box>
        )}
      </Box>
      <Box
        as={EActionAttribute.UL}
        listStyleType={'none'}
        maxHeight={isOpen ? height || 'auto' : '0'}
        transition={'all 0.3s'}
        overflowY={'hidden'}
      >
        <Box ref={childrenContentRef}>{children}</Box>
      </Box>
    </Box>
  );
};

export const TableOfContentChildItem = ({
  title,
  onClick,
  isActive,
}: Pick<TableContent, 'title' | 'isActive'> & {
  onClick: (text: string) => void;
}) => (
  <Box padding={'12px 16px 12px 40px'} as={EActionAttribute.LI}>
    <Box width={2} height={2} />
    <Link color={isActive ? EColor.ACCENT : EColor.SECONDARY} onClick={() => onClick(title)}>
      {title}
    </Link>
  </Box>
);
